module.exports = __webpack_public_path__ + "img/gb-home.ec0cbf18.png";